import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(Item(), {
    state() {
        return {
            id: null,
            gradebook_id: null,
            activity_id: null,
            activity_submission_id: null,
            user_id: null,
            points: null,
            grading_scheme_id: null,
            grading_scheme_criteria_id: null,
            overridden: null,
            overridden_reason: null,
            automatic: null,
            comments: null,
            updated_at: null,
            created_at: null,
            order: null,
        };
    },

    getters: {
        id: state => {
            return state.id;
        },
    },

    actions: {},

    mutations: {},
});
